import Vue from 'vue'
import Router from 'vue-router'
import customerManage from './modules/customer-manage'
import trustDeed from './modules/trust-deed'
import productionTask from './modules/production-task'
Vue.use(Router)
  // 定义路由规则
let router = new Router({
    mode: 'history',
    routes: [
      ...customerManage,
      ...trustDeed,
      ...productionTask,
      {
        path: '/',
        redirect: () => {
          return localStorage.getItem('redirectPath') || '/trust-deed-list'
        },
        name: 'home'
      },
      // {
      //   path: '/',
      //   name: 'home',
      //   component: resolve => require(['views/Home'], resolve),
      //   meta: { auth: true, view: 'pc' }
      // },
      {
        path: '/login',
        name: 'login',
        component: resolve => require(['views/login'], resolve),
        meta: { auth: false, view: 'defaultView' }
      },
      {
        path: '/gene-lab-order',
        name: 'gene-lab-order',
        component: resolve => require(['views/gene-lab-order'], resolve),
        meta: { auth: true, view: 'pc' }
      },
      {
        path: '/lab-order-detail/:id',
        name: 'lab-order-detail',
        props: true,
        component: resolve => require(['views/lab-order-detail'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '全部订单/订单详情' }
      },
      {
        path: '/order-handle/:status',
        name: 'order-handle',
        props: true,
        component: resolve => require(['views/order-handle'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '全部订单/异常订单处理' }
      },
      {
        path: '/business-order-lot-new',
        name: 'business-order-lot-new',
        component: resolve => require(['views/business-order-lot-new'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '全部订单/批量创建订单' }
      },
      {
        path: '/test',
        name: 'test',
        component: resolve => require(['views/test'], resolve),
        meta: { auth: true, view: 'pc' }
      },
      {
        path: '/export-history/mall_order_bill',
        name: 'export-history',
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: 'CPS缴费记录/CPS缴费记录导出历史' }
      },
      {
        path: '/edit-password',
        name: 'edit-password',
        component: resolve => require(['views/edit-password'], resolve),
        meta: { auth: true, view: 'pc' }
      },
      {
        path: '/debug/ueditor',
        name: 'ueditor',
        component: resolve => require(['views/debug/ueditor'], resolve),
        meta: { auth: true, view: 'pc' }
      },
      {
        path: '/export-history',
        props: true,
        name: 'export-history',
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc' }
      },
      {
        path: '/export-history/lab-order',
        name: 'export-history-lab-order',
        props: true,
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '全部订单/导出历史' }
      },
      {
        path: '/export-history/prod-task',
        name: 'export-history-prod-task',
        props: true,
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '生产任务/导出历史' }
      },
      {
        path: '/export-history/stock-in',
        name: 'export-history',
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '入库/导出历史' }
      },
      {
        path: '/export-history/stock-out',
        name: 'export-history',
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '出库/导出历史' }
      },
      {
        path: '/export-history/stock-quantifier',
        name: 'export-history',
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '库存/导出历史' }
      },
      {
        path: '/export-history/product-task',
        name: 'export-history',
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '生产任务/导出历史' }
      },
      {
        path: '/export-history/lab_chip_slot_assign_export',
        name: 'export-history',
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '历史芯片/导出历史' }
      },
      {
        path: '/export-history/bills',
        name: 'export-history',
        props: true,
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '委托单/导出历史' }
      },
      {
        path: '/export-history/bills_download',
        name: 'export-history',
        props: true,
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '委托单/委托单下载历史' }
      },
      {
        path: '/export-history/bills_download_report',
        name: 'export-history',
        props: true,
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '委托单/报告下载历史' }
      },
      {
        path: '/export-history/table_download_MR',
        name: 'export-history',
        props: true,
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '委托单/核磁表格下载历史' }
      },
      {
        path: '/export-history/table_download_in_out',
        name: 'export-history',
        props: true,
        component: resolve => require(['views/export-history'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '委托单/出入库表格下载历史' }
      },
      {
        path: '/lab-order-form/:isEdit/:id',
        name: 'lab-order-form',
        component: resolve => require(['views/lab-order-form'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '全部订单/订单', isForm: true }
      },
      {
        path: '/lab-product',
        name: 'lab-product',
        component: resolve => require(['views/lab-product'], resolve),
        meta: { auth: true, view: 'pc' }
      },
      {
        path: '/lab-product-detail/:id',
        props: true,
        name: 'lab-product-detail',
        component: resolve => require(['views/lab-product-detail'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '实验室产品/实验室产品详情' }
      },
      {
        path: '/lab-product/lab-product-form/:isEdit/:id',
        name: 'lab-product-form',
        props: true,
        component: resolve => require(['views/lab-product-form'], resolve),
        meta: { auth: true, view: 'pc', navInfo: '实验室产品/实验室产品', isForm: true }
      },
      {
        path: '/batch-add-lab-order',
        name: 'batch-add-lab-order',
        component: resolve => require(['views/batch-add-lab-order'], resolve),
        meta: { auth: true, view: 'pc' }
      },
      {
        path: '/distribute-task',
        name: 'distribute-task',
        props: true,
        component: resolve => require(['views/trust-deed/distribute-task'], resolve),
        meta: { auth: true, view: 'pc' }
      },
    {
      path: '/download-the-form',
      name: 'download-the-form',
      component: resolve => require(['views/download-the-form'], resolve),
      meta: { auth: true, view: 'pc' }
    }
    ]
  })
  /*
   * 路由拦截，每次路劲切换时触发，一般用来进行权限判定，更多使用方式参见vue-router导航钩子
   * to: 跳转目标的路由对象
   * from：跳转前的路由对象
   * next: 如果需要拦截跳转，则用next(false),否则用next()
   */
router.beforeEach((to, from, next) => {
  router.lastRouter = from;
  if (!to.meta.auth && to.name === 'login') {
    // 如果是直接进入的是登录页面并且处于已登录状态，则直接跳转到首页
    if (Vue.prototype.$auth.token()) {
      next({ path: '/' })
    }
  }
  next()
})
export default router